import { StatusTransition } from '../../types/interfaces/StatusTransition';
import IApiCalls from '../api/interfaces/apiCalls';

import BaseService from './BaseService';
import IStatusTransitionsService from './interfaces/StatusTransitionsService';

class StatusTransitionsService
  extends BaseService<StatusTransition>
  implements IStatusTransitionsService
{
  constructor(apiCalls: IApiCalls) {
    super(apiCalls, 'StatusTransitions');
  }
}

export default StatusTransitionsService;
